<!--
 * @Author: fanhengbin
 * @Date: 2021-07-15 19:08:33
 * @Descripttion:
-->
<template>
  <el-cascader
    v-model="selectedOptions"
    :placeholder="value||'请选择所在地区'"
    size="small"
    :options="options"
    clearable
    @change="handleChange"
  />
</template>

<script>
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: 'ChinaArea',
  components: {},
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      options: regionData,
      selectedOptions: []
    }
  },
  methods: {
    handleChange(value) {
      let arr = []
      this.selectedOptions.map((item) => (arr.push(CodeToText[item]) ))
      this.$emit('input', arr.join('|'))
    },
    handleTextToCode(arr) {
      // 上海、北京、天津直辖市 第二级为 市辖区
      if (arr[0].indexOf('北京') !== -1 || arr[0].indexOf('天津') !== -1 || arr[0].indexOf('上海') !== -1) {
        const temp = arr[1]
        if (temp.indexOf('北京') !== -1 || temp.indexOf('天津') !== -1 || temp.indexOf('上海') !== -1) {
          arr[1] = '市辖区'
        } else if (temp.indexOf('市辖区') === -1) {
          arr[1] = '市辖区'
          arr[2] = temp
        }
      }
      // 重庆 第二级是 区或县
      if (arr[0].indexOf('重庆') !== -1) {
        // 县级地点 且 第二级 不是 县
        if (arr[1].indexOf('县') !== 0 && arr[1].indexOf('县') !== -1) {
          const temp = arr[1]
          arr[1] = '县'
          arr[2] = temp
        } else if (arr[1].indexOf('市') !== 0) {
          const temp = arr[1]
          arr[1] = '市辖区'
          arr[2] = temp
        }
      }
      // 省区市信息
      const placeInfo = []

      const province = TextToCode[arr[0]]
      placeInfo[0] = province.code
      let city = ''
      if (arr.length > 1) {
        city = province[arr[1]]
        placeInfo[1] = city.code
      }
      let region = ''
      if (arr.length > 2) {
        if (city[arr[2]]) {
          region = city[arr[2]]
          placeInfo[2] = region.code
        }
      }
      this.selectedOptions = placeInfo
    }
  }
}
</script>
